import React, { useEffect, useState } from "react";
import { useRef } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import axios from "../../../../lib/axios";
import { Slide, toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import UnLock from "../../../../GlobalFunction/UnLock";
import axiosInstance from "../../../../lib/axios";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";
import { Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";
import CrudButtons from '../../../../GlobalFunction/CrudButtons'
import { useReactToPrint } from "react-to-print";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";
import CustomAutocomplete from "../../../AutoComplete/AutocompletewithoutIcon";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { IconButton, Input } from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';

const columns = [
  { id: 'RowNum', label: 'Sr.No.', minWidth: 10 },
  { id: 'HkWrkrName', label: 'HkWrkrName', minWidth: 100 },
  { id: 'Abrv', label: 'Abrv', minWidth: 100 },
  { id: 'Remark', label: 'Remark', minWidth: 100 },
  { id: 'Status', label: 'Status', minWidth: 20 },
];

const HkWorker = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    HkWrkrName: "",
    HkWrkrNo: "",
    HkWrkTypeId: "",
    VendId: "",
    Addr: "",
    Vendor: "",
    GuardianNm: "",
    WrkrImg: "",
    ImgName: "",
    Gender: "",
    AdharNo: "",
    PanNo: "",
    MobileNo: "",
    Email: "",
    RefBy: "",
    Abrv: "",
    Remark: "",
    Status: "1",
  });

  const [error, setError] = useState({
    HkWrkrName: false,
    HkWrkTypeId: false,
  });

  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [currentHkWrkrId, setCurrentHkWrkrId] = useState(null);
  const [mode, setMode] = useState("view");
  const [lastInsertedHkTypeId, setLastInsertedHkTypeId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [UserId] = useState(sessionStorage.getItem("UserId"));
  const [Status, setStatus] = useState("1");
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const [worktype, setWorktype] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });
  const HkTypeNameRef = useRef(null);
  const AbrvRef = useRef(null);
  const RemarkRef = useRef(null);
  const GuardianRef = useRef(null);
  const addrRef = useRef(null);
  const fileInputRef = useRef(null);
  const [image, setImage] = useState(null);
  const [gender, setGender] = useState("F");
  const [vendor, setVendor] = useState([]);

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
    setFormData((prevData) => ({
      ...prevData,
      Status: updatedStatus
    }))
  };

  const handleGenderChange = (e) => {
    setGender(e.target.value);
  };

  useEffect(() => {
    const fetchWorkTypes = async () => {
      try {
        const response = await axios.post('MstHkWrkType/getMstHkWrkTypedrp');

        const { data: { Status, Data } } = response;

        if (Status === 0 && Array.isArray(Data)) {
          setWorktype(Data);
        } else {
          setWorktype([]);
        }
      } catch (error) {
        toast.error('Failed to fetch work types:', error);
      }
    };

    fetchWorkTypes();
  }, []);

  useEffect(() => {
    const fetchVendor = async () => {
      try {
        const response = await axiosInstance.post("PartyMst/getPartyMstdrp", {
          PartyCat: "SP"
        });
        if (response.data.Status === 0 && Array.isArray(response.data.Data)) {
          setVendor(response.data.Data);
        };
      } catch (error) {
        toast.error("Error while fetching vendor");
      }
    };
    fetchVendor();
  }, [])

  useEffect(() => {
    const getRow = async () => {
      try {
        const res = await axiosInstance.post('MstHkWrkr/getAllMstHkWrkrDashBoard',
          {
            start: 0,
            PageSize: 0,
            SearchText: ""
          });

        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        }
      } catch (err) {
        toast.error('Error fetching data:', err);
      }
    };

    getRow();
  }, []);

  useEffect(() => {
    if (location.state && location.state.HkWrkrId) {
      setCurrentHkWrkrId(location.state.HkWrkrId);
      fetchHkWorkerData(location.state.HkWrkrId);
      setMode("view");
    } else {
      setMode("add");
      setIsFormDisabled(false);
    }
  }, [location]);

  const fetchHkWorkerData = async (id, flag) => {
    try {
      const response = await axios.post(`MstHkWrkr/RetriveMstHkWrkr`, {
        HkWrkrId: parseInt(id),
        Flag: flag,
      });
      const { data: { Status, Data, responseStatusCode } } = response;
      if (Status === 0 && responseStatusCode === 1 && Data) {
        const HkWorkerData = Data[0];
        const fixedImageUrl = HkWorkerData.WrkrImg.startsWith('http:/')
          ? HkWorkerData.WrkrImg.replace('http:/', 'http://')
          : HkWorkerData.WrkrImg;
        setFormData({
          HkWrkrName: HkWorkerData.HkWrkrName,
          HkWrkrNo: HkWorkerData.HkWrkrNo,
          GuardianNm: HkWorkerData.GuardianNm,
          AdharNo: HkWorkerData.AdharNo,
          PanNo: HkWorkerData.PanNo,
          Email: HkWorkerData.Email,
          MobileNo: HkWorkerData.MobileNo,
          Gender: HkWorkerData.Gender,
          RefBy: HkWorkerData.RefBy,
          VendId: HkWorkerData.VendId || "",
          Addr: HkWorkerData.Addr,
          HkWrkTypeId: HkWorkerData.HkWrkTypeId,
          WrkrImg: fixedImageUrl,
          ImgName: HkWorkerData.ImgName,
          Abrv: HkWorkerData.Abrv,
          Remark: HkWorkerData.Remark,
          Status: HkWorkerData.Status,
        });
        setStatus(Data[0].Status.toString());
        setIsFormDisabled(true);
        setImage(null);
        setCurrentHkWrkrId(HkWorkerData.HkWrkrId);
      } else if (
        response.data.Status === 1 && response.data.responseStatusCode === 2) {
        // toast.info(response.data.Message, { autoClose: 1000 });
      }
    } catch (error) {
      toast.error("Error fetching housekeepingtype data:", error);
    }
  };

  const handlePrevious = async () => {
    if (currentHkWrkrId && currentHkWrkrId > 1) {
      await fetchHkWorkerData(currentHkWrkrId, "P");
    }
  };

  const handleNext = async () => {
    if (currentHkWrkrId) {
      await fetchHkWorkerData(currentHkWrkrId, "N");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "HkWrkr") {
      setFormData((prevState) => ({
        ...prevState,
        state: "",
      }));
    }

    if (name === "HkWrkr" && value !== "") {
      setTimeout(() => {
        AbrvRef.current.focus();
      }, 100000);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64Image = reader.result;
        const imageName = file.name;

        setFormData(prevFormData => ({
          ...prevFormData,
          WrkrImg: base64Image,
          ImgName: imageName,
        }));

        setImage(base64Image);
      };

      reader.readAsDataURL(file);  // Convert the file to base64
    }
  };

  const handleRemoveImage = () => {
    setImage(null);
  };

  const handleKeyPress = (event, nextRef) => {
    if (event.key === "Enter" && nextRef) {
      event.preventDefault();
      nextRef.current.focus();
    }
  };

  const handleEdit = async () => {
    setMode("edit");
    setIsFormDisabled(false);
  };

  const handleAdd = () => {
    setMode("add");
    setIsFormDisabled(false);
    setFormData({
      HkWrkrName: "",
      HkWrkrNo: "",
      HkWrkTypeId: "",
      VendId: "",
      Addr: "",
      Vendor: "",
      VendId: "",
      GuardianNm: "",
      WrkrImg: "",
      ImgName: "",
      Gender: "F",
      AdharNo: "",
      PanNo: "",
      MobileNo: "",
      Email: "",
      RefBy: "",
      Abrv: "",
      Remark: "",
      Status: "1",
    });
    setCurrentHkWrkrId(null);
    setImage(null);
    setTimeout(() => {
      HkTypeNameRef.current.focus();
    }, 0);
  };

  // const handleCancel = async () => {
  //   if (mode === "add") {
  //     await fetchHkWorkerData(1, "L");
  //   } else {
  //     await UnLock(currentHkWrkrId, "MstHkType", "HkWrkrId");
  //     await fetchHkWorkerData(currentHkWrkrId, "R");
  //   }
  //   setMode("view");
  //   setIsFormDisabled(true);
  // };

  const handleCancel = async () => {
    if (mode === "add") {
      setFormData({
        HkWrkrName: "",
        HkWrkrNo: "",
        HkWrkTypeId: "",
        VendId: "",
        Addr: "",
        Vendor: "",
        GuardianNm: "",
        WrkrImg: "",
        ImgName: "",
        Gender: "F",
        AdharNo: "",
        PanNo: "",
        MobileNo: "",
        Email: "",
        RefBy: "",
        Abrv: "",
        Remark: "",
        Status: "1",
      });
      setImage(null);
      setMode("view");
      setIsFormDisabled(true);
      setCurrentHkWrkrId(null);
    } else {
      if (currentHkWrkrId) {
        await UnLock(currentHkWrkrId, "MstHkType", "HkWrkrId");
        await fetchHkWorkerData(currentHkWrkrId, "R");
      }
      setMode("view");
      setIsFormDisabled(true);
    }
  };

  const handleExit = () => {
    navigate("/hk-worker-table");
  };

  const handleDelete = async () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false);
    try {
      const response = await axiosInstance.post(`MstHkWrkr/RetriveMstHkWrkr`, {
        HkWrkrId: currentHkWrkrId,
        Flag: "D",
      });

      if (response instanceof Error) {
        return toast.error("Error Could not delete HKType");
      }
      const { data: { Status, Message, Data } } = response;
      if (Status === 0) {
        toast.success(Message, { autoClose: 500 });
        await fetchHkWorkerData(currentHkWrkrId, "N");
      } else {
        if (Array.isArray(Data) && Data.length > 0) {
          const msg = formatDeleteErrorMessage(Data);
          toast.error(msg, { autoClose: 500 });
        } else {
          toast.error(Message, { autoClose: 500 });
        }
      }
      // await UnLock(currentHkWrkrId, "MstHkType", "HkWrkrId");
      setIsFormDisabled(true);
    } catch (error) {
      toast.error("Error deleting housekeepingtype:", error);
    }
  };

  const handleSubmit = async () => {
    let hasError = false;

    setError({
      HkWrkrName: false,
      HkWrkTypeId: false,
    });

    if (!formData.HkWrkrName?.trim()) {
      toast.error("Worker Name is required");
      setError(prev => ({ ...prev, HkWrkrName: true }));
      HkTypeNameRef.current?.focus();
      return;
    }

    if (!formData.HkWrkTypeId) {
      toast.error("Worker Type is required");
      setError(prev => ({ ...prev, HkWrkTypeId: true }));
      return;
    }

    if (hasError) {
      return;
    }

    try {
      const payload = {
        HkWrkrName: formData.HkWrkrName,
        HkWrkTypeId: formData.HkWrkTypeId,
        Abrv: formData.Abrv,
        VendId: formData.VendId || '1',
        RefBy: formData.RefBy,
        Email: formData.Email,
        Gender: formData.Gender,
        GuardianNm: formData.GuardianNm,
        AdharNo: formData.AdharNo,
        PanNo: formData.PanNo,
        MobileNo: formData.MobileNo,
        Addr: formData.Addr,
        WrkrImg: formData.WrkrImg,
        ImgName: formData.ImgName,
        Remark: formData.Remark,
        status: formData.Status,
      };

      let response;
      if (mode === "edit") {
        payload.HkWrkrId = currentHkWrkrId;
        payload.UpdatedBy = parseInt(UserId, 10);
        // await UnLock(currentHkWrkrId, "MstHkType", "HkWrkrId");
        response = await axios.post(`MstHkWrkr/UpdateMstHkWrkr`, payload);
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axios.post(`MstHkWrkr/InsertMstHkWrkr`, payload);
      }

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message, { autoClose: 1000 });
        if (mode === "add") {
          setLastInsertedHkTypeId(response.data.Data);
          await fetchHkWorkerData(response.data.Data);
          setMode("view");
          setIsFormDisabled(true);
          setCurrentHkWrkrId(response.data.Data);
        } else {
          setMode("view");
        }
        setIsFormDisabled(true);
      }
    } catch (error) {
      toast.error("Error saving/updating housekeepingtype:", error);
    }
  };

  return (
    <>
      <Box className="form-container"
        sx={{
          width: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
          maxWidth: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
          height: { xs: "91.5vh", sm: "93.5vh", md: "auto", lg: "90vh" },
          overflowX: "hidden",
          overflowY: { xs: "auto", sm: "hidden", md: "hidden", lg: "hidden" },
        }}>
        <ToastContainer />
        <Grid container spacing={2}
          sx={{
            width: { xs: "93%", sm: "80%", md: "80%" },
            height: { xs: "500px", sm: "450px", md: "auto", lg: "auto" },
            marginInline: "auto",
            marginTop: { xs: "60px", sm: "50px", md: "auto" },
            marginBottom: { xs: "110px", sm: "10px", md: "auto" },
            borderRadius: "8px",
            padding: { xs: "0px 5px 5px 5px", sm: "0px 20px 20px 20px" },
            backgroundColor: "#fff",
          }}
        >
          <Grid item xs={12} className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
              flexDirection: { xs: "column", sm: "row", md: "row" },
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                marginBottom: { xs: "10px", sm: 0 },
              }}
            >
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  marginRight: { xs: "5px", sm: "10px" },
                  display: "block",
                }}
                className="three-d-button-previous"
                onClick={handlePrevious}
                disabled={
                  mode !== "view" || !currentHkWrkrId || currentHkWrkrId === 1
                }
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  display: "block",
                }}
                className="three-d-button-next"
                onClick={handleNext}
                disabled={mode !== "view" || !currentHkWrkrId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            <Typography
              variant="h5"
              sx={{
                margin: "Auto",
                textAlign: { xs: "center", sm: "center" },
                fontSize: { xs: "24px", sm: "18px", md: "24px" },
              }}
            >
              Worker Master
            </Typography>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Worker Master"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onView={handlePrint}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={mode === 'view'}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_field" sx={{ marginInline: { xs: "10px", sm: "80px" } }}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="HkWrkrNo"
                  name="HkWrkrNo"
                  label="Code"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.HkWrkrNo}
                  onChange={handleInputChange}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="HkWrkrName"
                  name="HkWrkrName"
                  label={
                    <span>
                      Worker Name <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.HkWrkrName}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.HkWrkrName}
                  helperText={error.HkWrkrName && ""}
                  inputRef={HkTypeNameRef}
                  onKeyDown={(event) => handleKeyPress(event, AbrvRef)}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <CustomAutocomplete
                  id="workertypename-select"
                  name="HkWrkTypeId"
                  options={worktype}
                  value={worktype.find((wktype) => wktype.HkWrkTypeId === formData.HkWrkTypeId) || ''}
                  onChange={handleInputChange}
                  label={
                    <span>
                      Worker Type <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  disabled={mode === "view"}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="Abrv"
                  name="Abrv"
                  label="Abrv"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Abrv}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={AbrvRef}
                  onKeyDown={(event) => handleKeyPress(event, RemarkRef)}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <CustomAutocomplete
                  id="VendId-select"
                  name="VendId"
                  options={vendor}
                  value={vendor.find((vend) => vend.Id === formData.VendId) || null}
                  onChange={handleInputChange}
                  label="Vendor/Contractor"
                  disabled={isFormDisabled}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Grid container alignItems="center">
                    <FormLabel id="demo-row-radio-buttons-group-label" sx={{ marginRight: 2 }}>
                      Gender:
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      value={formData.Gender || "F"}
                      onChange={(e) => {
                        setFormData(prev => ({
                          ...prev,
                          Gender: e.target.value
                        }));
                      }}
                    >
                      <FormControlLabel
                        value="F"
                        control={<Radio size="small" disabled={isFormDisabled} />}
                        label="Female"
                      />
                      <FormControlLabel
                        value="M"
                        control={<Radio size="small" disabled={isFormDisabled} />}
                        label="Male"
                      />
                    </RadioGroup>
                  </Grid>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="GuardianNm"
                  name="GuardianNm"
                  label="Spouse/Father"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.GuardianNm}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={GuardianRef}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="AdharNo"
                  name="AdharNo"
                  label="Adhar No"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.AdharNo}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="PanNo"
                  name="PanNo"
                  label="Pan No"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.PanNo}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="MobileNo"
                  name="MobileNo"
                  label="Mobile No"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.MobileNo}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="Email"
                  name="Email"
                  label="Email"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Email}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="RefBy"
                  name="RefBy"
                  label="Ref By"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.RefBy}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={8}>
                <TextField
                  id="Addr"
                  name="Addr"
                  label="Address"
                  variant="filled"
                  fullWidth
                  multiline
                  rows={2}
                  className="custom-textfield"
                  value={formData.Addr}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={addrRef}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={2}>
                <Box
                  sx={{
                    width: '70%',
                    height: 100,
                    border: '1px solid #130101ff',
                    borderRadius: 2,
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: formData.WrkrImg ? 'transparent' : '#f5f5f5',
                  }}
                >
                  {formData.WrkrImg ? (
                    <img
                      src={formData.WrkrImg}
                      alt="Uploaded"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        borderRadius: 2,
                      }}
                    />
                  ) : (
                    <IconButton
                      sx={{
                        position: 'absolute',
                        backgroundColor: '#ffffff',
                        padding: 2,
                        borderRadius: '50%',
                        boxShadow: 2,
                        '&:hover': {
                          backgroundColor: '#e0e0e0',
                        },
                      }}
                      onClick={() => fileInputRef.current.click()}
                      disabled={isFormDisabled}
                      aria-label="upload photo"
                    >
                      <PhotoCameraIcon />
                    </IconButton>
                  )}
                </Box>

                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: 'none' }}
                  accept="image/*"
                  onChange={handleImageChange}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={1}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={image ? handleRemoveImage : () => fileInputRef.current.click()}
                  disabled={isFormDisabled}
                >
                  {image ? 'Remove' : 'Upload'}
                </Button>
              </Grid>

              <Grid item xs={12} md={6} lg={8}>
                <TextField
                  id="Remark"
                  name="Remark"
                  label="Remark"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Remark}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={RemarkRef}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={mode === 'view'}
                        checked={Status == "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button"
            sx={{ marginBottom: "10px", marginInline: "10px" }}
          >
            {mode === "view" && (
              <>
                <Button variant="contained" sx={{ mr: 1, background: "linear-gradient(290deg, #d4d4d4, #ffffff)" }}
                  onClick={handleAdd}
                  disabled
                >
                  Submit
                </Button>
                <Button variant="contained"
                  sx={{ mr: 1, background: "linear-gradient(290deg, #a7c5e9, #ffffff)" }}
                  onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === "edit" || mode === "add") && (
              <>
                <Button variant="contained"
                  sx={{ mr: 1, background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)", }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
                <Button variant="contained"
                  sx={{ mr: 1, background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)" }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>
      <div style={{ display: "none" }}>
        {rows.length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows.map(row => ({
              ...row,
              Status: row.Status === "1" ? "Active" : row.Status === "0" ? "Inactive" : row.Status,
            }))}
            title="HK Type Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: "#f5f5f5" }}
          />
        )}
      </div>
      {/* Delete Confirmation Modal */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default HkWorker;